




































import Vue, { PropType } from 'vue';
import {
  MINUTES_IN_DAY,
  setPartsToUTCDate,
  setUTCPartsToDate
} from '@/utils/dateHelpers';

import moment from 'moment';
import dateFormat from '@/filters/dateFormat';

const prop = 'value',
  event = 'input';

export default Vue.extend({
  name: 'TimePicker',
  model: { prop, event },

  props: {
    value: {
      type: [Date, String] as PropType<Date | string>,
      default: () => new Date(),
      required: true
    },

    compare: {
      type: [Date] as PropType<Date>,
      required: false
    },

    intervalMinutes: {
      type: Number,
      default: 30
    },

    labels: {
      default() {
        return {
          prevMonth: 'Previous month',
          nextMonth: 'Next month'
        };
      }
    }
  },

  data() {
    return {
      open: false,
      lazyValue: this.value
    };
  },

  computed: {
    internalValue: {
      get(): Date | string {
        return this.lazyValue;
      },
      set(val: Date | string) {
        this.lazyValue = val;
      }
    },

    formattedDate(): string {
      return this.value ? dateFormat(this.value, 'h:mma') : '';
    },

    intervals(): Date[] {
      // Intervals to span a full day regardless of compared date?
      // discuss with lamar about start day
      const count = MINUTES_IN_DAY / this.intervalMinutes;
      const timestamp = [];
      const start = setUTCPartsToDate(
        this.internalValue ? new Date(this.internalValue) : new Date()
      );
      for (let i = 0; i < count; i++) {
        const hours = Math.floor(i / 2);
        const minutes = (i % 2) * 30;
        const incrementedDate = new Date(
          start.getFullYear(),
          start.getMonth(),
          start.getDate(),
          hours,
          minutes
        );
        timestamp.push(incrementedDate);
      }
      return timestamp;
    }
  },

  watch: {
    open(value: boolean) {
      if (value) {
        const length = this.intervals.length;
        for (let i = 0; length > i; i++) {
          const internalValueUTCDate = moment(
            this.internalValue as Date
          ).format('HHmm');
          const currentInterval = this.intervals[i];
          const incrementedInterval = this.intervals[(i + 1) % length];
          if (
            internalValueUTCDate >= moment(currentInterval).format('HHmm') &&
            internalValueUTCDate <= moment(incrementedInterval).format('HHmm')
          ) {
            setTimeout(() => {
              const nextIntervalId = `id-${this.intervals[
                (i + 1) % length
              ].getMilliseconds()}${i}`;

              document
                .getElementById(nextIntervalId)!
                .scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 200);
            break;
          }
        }
      }
    },
    value: {
      handler(val: any) {
        this.internalValue = val;
      },
      immediate: true
    }
  },

  methods: {
    moment,
    dateFormat,

    async parseDate(val: any) {
      const timeRegExpPattern = RegExp(
        /(\d{1,2})(:|\s)(\d{2})\s*([AaPp][Mm])$/g
      );

      if (timeRegExpPattern.test(val)) {
        let hours = Number(val.match(/^(\d+)/)![1]);
        const minutes = Number(val.match(/:(\d+)/)![1]);
        const AMPM = val.match(/\s*([AaPp][Mm])$/)![1];

        // Convert time from 12hr to 24hr representation
        if (AMPM.toLowerCase() == 'pm' && hours < 12) hours = hours + 12;
        if (AMPM.toLowerCase() == 'am' && hours == 12) hours = hours - 12;

        const currentDate = this.value ? new Date(this.value) : new Date();

        const updatedDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate(),
          hours,
          minutes
        );
        // Allow third party library to parse any dates available to use
        const precDate = moment(updatedDate);

        if (precDate.isValid()) {
          return this.$emit(event, setPartsToUTCDate(precDate.toDate()));
        }
      }
    },

    selectText(e: Event) {
      const input = (this as any).$refs.timeField.$refs
        .input as HTMLInputElement;
      if (input.setSelectionRange) {
        input.setSelectionRange(0, input.value.length);
        return;
      } else {
        input.select();
      }
      return;
    },

    updateTime(date: string) {
      // details start is updated
      return this.$emit('input', date);
    },

    selectTime(day: Date) {
      const date = moment(this.internalValue as string)
        .startOf('day')
        .add(day.getHours(), 'hour')
        .add(day.getMinutes(), 'minutes')
        .format('YYYY-MM-DDTHH:mm:ss');

      this.updateTime(date);
      this.open = false;
    }
  }
});
